import React, { useState } from "react";
import { Landmark, Building2, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { LENDERS } from "../data/lenders";

const ICONS = { Landmark, Building2 };

export const LenderCard = ({ slug, product = "personal", basePath = "/personal-loan", index = 0 }) => {
  const lender = LENDERS[slug];
  if (!lender || !lender[product]) return null;
  const p = lender[product];
  const Icon = ICONS[lender.icon] || Landmark;
  return (
    <div
      data-testid={`lender-card-${slug}`}
      className="ol-card-hover bg-white border border-[#E2E8F0] rounded-xl p-6 ol-fade-up"
      style={{ animationDelay: `${index * 40}ms` }}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ background: `${lender.color}15` }}>
            <Icon size={22} style={{ color: lender.color }}/>
          </div>
          <div>
            <h3 className="font-semibold text-[#273B59] font-heading leading-tight">{lender.name}</h3>
            <p className="text-xs text-[#475569] mt-0.5">RBI Registered Lender</p>
          </div>
        </div>
        <Badge className="bg-[#EAF5FD] text-[#1088D4] hover:bg-[#EAF5FD] border-0">Indicative</Badge>
      </div>

      <div className="mt-5 grid grid-cols-3 gap-2 pt-4 border-t border-[#E2E8F0]">
        <Cell label="Interest Rate" value={p.rate} highlight/>
        <Cell label="Max Amount" value={p.maxAmount}/>
        <Cell label="Tenure" value={p.tenure}/>
      </div>

      <div className="mt-5 flex gap-2">
        <Link to={`${basePath}/${slug}`} className="flex-1">
          <Button data-testid={`view-details-${slug}`} variant="outline" className="w-full border-[#1088D4] text-[#1088D4] hover:bg-[#EAF5FD]">View Details</Button>
        </Link>
        <Link to={`/apply?lender=${slug}&product=${product}`} className="flex-1">
          <Button data-testid={`apply-${slug}`} className="w-full ol-btn-primary">Apply <ArrowRight size={14} className="ml-1"/></Button>
        </Link>
      </div>
    </div>
  );
};

const Cell = ({ label, value, highlight }) => (
  <div className="text-center">
    <div className="text-[10px] uppercase tracking-wider text-[#94A3B8] font-medium">{label}</div>
    <div className={`mt-1 text-xs font-semibold ${highlight ? "text-[#16A34A]" : "text-[#273B59]"}`}>{value}</div>
  </div>
);
